import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService, AuthType } from '../services/auth.service';
import { catchError, concatMap, map } from 'rxjs/operators';
import { forkJoin, Observable, of } from 'rxjs';
import { Addon } from '../models/addon.model';
import { GroupsService } from '../../groups/groups.service';
import { AdminRole } from '../enums/enums';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class TechnadoptTokenResolverGuard  {

  canManage: boolean = false;
  isAuthenticated: boolean = false;

  constructor(private auth: AuthService, private groupsService: GroupsService, private userService: UserService, private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    if (route?.queryParams?.isdefault === 'true') {
      return of(null);
    }
    return this.resolveToken();
  }

  public resolveToken(checkAdmin: boolean = true): Observable<any> {
    return this.auth.getAuthAddonByType(AuthType.Technadopt).pipe(
      concatMap(
        (technadoptAddon: Addon) => {
          return forkJoin([this.auth.getTechnadoptAuthorizedTokenIfRequired(technadoptAddon, this.auth.idenediGroupId), checkAdmin ? this.getCanManage() : of(false)]).pipe(
            concatMap(([addon, canManage]) => {
              const accessList = this.getTechnadoptAccessList(technadoptAddon);
              const allAccessLists = this.getAllAccessLists(accessList);
              return this.getUserAccessListIds(technadoptAddon, accessList).pipe(map((userAccessListIds) => {
                return { addon, canManage, userAccessListIds, allAccessLists };
              }));
            }))
        }))
  }
  // private getCanManage() {
  //   if (this.auth.isLoggedIn() && this.auth.idenediGroupId) {
  //     return this.groupsService
  //       .getGroupDetails(this.auth.idenediGroupId).pipe(map(group => {
  //         // this check implement reasion behind appRoles not set in groupDetails service thats why i implement this senarios
  //         if (group.GroupMembershipStatus == 'Member') {
  //           return this.userService.getMembers(localStorage.getItem('idenedi.user.id')).subscribe(
  //             (members: any) => {
  //               const hasTechnadoptRole = members.some(member => (member.AppRoles?.Technadopt[0] == '1'));
  //               if (hasTechnadoptRole) {
  //                 return true;
  //               }
  //               return of(false);
  //             })
  //         }
  //         else {
  //           return group.GroupAdminRoles.some(role => [AdminRole.ContentCreator, AdminRole.FullControl].includes(role))
  //         }
  //       }));
  //   }
  //   return of(false);
  // }
  // if provide group inside app roles then revert
  private async getCanManage(): Promise<boolean> {
    if (this.auth.isLoggedIn() && this.auth.idenediGroupId) {
      try {
        const group = await this.groupsService.getGroupDetails(this.auth.idenediGroupId).toPromise();

        // Check if the user is a member
        if (group.GroupMembershipStatus === 'Member') {
          // const members = await this.userService.getMembers(localStorage.getItem('idenedi.user.id')).toPromise();

          // // Check for Technadopt role
          // const hasTechnadoptRole = members.some((member: any) => member.AppRoles?.Technadopt?.[0] === '1');
          // return hasTechnadoptRole ? true : false;

          const group = await this.groupsService.getGroupDetails(this.auth.idenediGroupId).toPromise();

          // Check for Technadopt role
          const hasTechnadoptRole = group.AppRoles?.Technadopt?.[0] === '1';
          return hasTechnadoptRole ? true : false;
        } else {
          // Check if the user has admin roles
          return group.GroupAdminRoles.some(role =>
            [AdminRole.ContentCreator, AdminRole.FullControl].includes(role)
          );
        }
      } catch (error) {
        console.error('Error:', error);
        return false; // Handle errors and return false
      }
    }
    return false; // Return false if not logged in or no group ID
  }



  public getTechnadoptAccessList(addon: Addon): any[] {
    let visibleBy = addon?.PublicProperties?.subgroupsAccessList ?
      JSON.parse(JSON.stringify(addon?.PublicProperties?.subgroupsAccessList)) : [];
    if (addon?.PublicProperties?.organziationId && this.auth.idenediGroupId) {
      let mainGroup = {};
      mainGroup[this.auth.idenediGroupId] = addon?.PublicProperties?.organziationId;
      visibleBy.push(mainGroup);
    }
    return visibleBy;
  }

  private getAllAccessLists(accessList: any = []) {
    const mappedAccList = accessList.map(acl => Object.values(acl)[0]).join().split(',');
    return [...new Set(mappedAccList)].join();
  }

  private getUserAccessListIds(addon: any, accessList: any = []) {
    this.isAuthenticated = this.auth.isLoggedIn();
    if (!this.isAuthenticated) {
      return of(accessList?.find((acl) => !!acl["anonymous"])?.anonymous || addon?.PublicProperties?.organziationId);
    }
    return this.userService.getUserDetail(this.auth.getCurrentUserId()).pipe(map(user => {
      const filteredAcl = accessList.filter(acl => {
        const groupId = Object.keys(acl)[0]; //can be '0' , 'anonymous', or valid group/subgroup Id
        if (groupId === 'admins') {
          return true;
        }
        return user.UserTitles.some(ut => ut.GroupIdenedi == groupId);
      }).map(acl => Object.values(acl)[0]).join().split(',');
      return [...new Set(filteredAcl)].join();
    }));
  }

}
